// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"527":"79d3b719","709":"dc7b42cd","787":"3aeda83d","935":"e1fd8f3e"}[chunkId] + ".chunk.js";
};